export default __webpack_public_path__ + "static/media/Create-documentation.a381ddb2.md";